import { useEffect } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { clearKeystore, getKeystore } from "../../services/keystore"
import { isValidMixinVersion } from "../../helpers/context"
import { isProductionGuard } from "../../constant"

export const AuthGuard = () => {
  const navigate = useNavigate()
  const location = useLocation()
  useEffect(() => {
    if (isProductionGuard) {
      clearKeystore()
      navigate("/auth", { replace: true })
      return
    }

    if (!isValidMixinVersion()) {
      navigate("/auth", { replace: true })
      return
    }

    const keystore = getKeystore()
    if (keystore) {
      return
    }
    clearKeystore()
    navigate("/auth", { replace: true })
  }, [navigate, location])

  return <Outlet />
}
